export default __webpack_public_path__ + "assets/img/sello_confianza-online.svg";